import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

export function getAccountEmail(account) {
  if (!account) return '';
  const raw =
    account.username ||
    account.idTokenClaims?.preferred_username ||
    account.idTokenClaims?.email ||
    account.idTokenClaims?.upn ||
    '';
  return String(raw).toLowerCase();
}

export function useNpsAccess() {
  const { accounts } = useMsal();
  const [allowed, setAllowed] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const res = await fetch(`${process.env.PUBLIC_URL || ''}/nps-allowed-users.json`, {
          cache: 'no-store',
        });
        if (!res.ok) throw new Error('Failed to load NPS access list');
        const data = await res.json();
        const users = (data.users || []).map((u) => String(u).toLowerCase());
        const email = getAccountEmail(accounts[0]);
        if (!cancelled) {
          setAllowed(Boolean(email) && users.includes(email));
          setChecked(true);
        }
      } catch {
        if (!cancelled) {
          setAllowed(false);
          setChecked(true);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [accounts]);

  return { allowed, checked };
}
